import { css, Global, Theme } from '@emotion/react';
import '@fontsource/cormorant-garamond/500.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import emotionNormalize from 'emotion-normalize';
import { h1, h2, h3, h4, h5, h6 } from './Typography';

export const theme: Theme = {
    colors: {
        gray1: '#fff',
        gray2: '#D8D7D3',
        gray3: '#ACABA7',
        gray4: '#88857D',
        gray5: '#131312',
        green1: '#E0EAE2',
        green2: '#B9E2B9',
        green3: '#70BFAC',
        green4: '#017860',
        green5: '#00271E',
    },
    spacing: {
        md: '2.22vw', //32px at 1440px wide viewport
        lg: '4.45vw', //64px ^^
        xl: '6.67vw', //96px ^^
        xxl: '8.89vw', //128px ^^
    },
};

export const GlobalStyles = () => {
    return (
        <Global
            styles={() => css`
                ${emotionNormalize};

                html {
                    font-size: 100%;
                    scroll-behavior: smooth;
                }

                body {
                    color: ${theme.colors.gray5};
                    font-family: 'Montserrat', sans-serif;
                    font-weight: normal;
                    font-size: 1rem;
                    line-height: 158.4%;
                    font-weight: 500;
                    word-wrap: break-word;
                    font-kerning: normal;
                    word-wrap: break-word;
                    -webkit-font-smoothing: antialiased;
                }

                h1 {
                    ${h1};
                }

                h2 {
                    ${h2};
                }

                h3 {
                    ${h3};
                }

                h4 {
                    ${h4};
                }

                h5 {
                    ${h5};
                }

                h6 {
                    ${h6};
                }

                a {
                    text-decoration: none;
                    color: ${theme.colors.gray5};
                    outline: none;
                    background-color: transparent;
                    -webkit-text-decoration-skip: objects;
                }

                *,
                *:before,
                *:after {
                    box-sizing: border-box;
                }

                img {
                    max-width: 100%;
                    display: block;
                    margin: 0;
                    padding: 0;
                }

                ul,
                ol {
                    padding-inline-start: 24px;
                }

                button {
                    :disabled {
                        opacity: 0.5;
                        pointer-events: none;
                    }
                }
            `}
        />
    );
};
